import PageHead from "@/components/PageHead";
import Reveal from "@/components/Reveal";

const SECTIONS = [
  {
    title: "1. Coleta e uso de dados pessoais",
    body: "Coletamos apenas os dados que você informa voluntariamente por meio do formulário de contato: nome, empresa, e-mail corporativo, telefone, serviço de interesse e a descrição da sua necessidade. Não coletamos dados sensíveis e não utilizamos suas informações para fins distintos dos descritos nesta política.",
  },
  {
    title: "2. Finalidade do tratamento de dados corporativos",
    body: "Os dados informados são utilizados exclusivamente para responder à sua solicitação, elaborar propostas técnicas, agendar reuniões e prestar os serviços contratados. Você poderá solicitar o descarte das informações a qualquer momento.",
  },
  {
    title: "3. Compartilhamento e armazenamento seguro",
    body: "Seus dados são armazenados em ambiente controlado e não são vendidos, alugados ou compartilhados com terceiros para fins comerciais. O acesso às informações é restrito às pessoas envolvidas no atendimento da sua solicitação.",
  },
  {
    title: "4. Direitos do titular (LGPD — Lei 13.709/2018)",
    body: "Nos termos da Lei Geral de Proteção de Dados, você pode solicitar a qualquer momento: a confirmação do tratamento dos seus dados, o acesso às informações que mantemos, a correção de dados incompletos ou inexatos, a portabilidade, a anonimização, o bloqueio ou a eliminação de dados desnecessários ou tratados em descumprimento à lei.",
  },
  {
    title: "5. Uso de cookies e tecnologias de navegação",
    body: "Este site pode utilizar ferramentas de análise de navegação com o objetivo de melhorar a experiência de uso. Essas ferramentas podem coletar dados técnicos como páginas visitadas, tempo de permanência e tipo de dispositivo. Você pode configurar seu navegador para bloquear ou remover cookies.",
  },
  {
    title: "6. Contato com o encarregado de dados (DPO)",
    body: "Para exercer seus direitos ou esclarecer dúvidas sobre esta política, entre em contato pelo e-mail contato@iprsinf.com.br — canal oficial do encarregado de dados da IPRS Soluções em TI.",
  },
];

export default function Privacy() {
  return (
    <div>
      <PageHead
        title="Política de Privacidade & LGPD | IPRS Soluções em TI"
        description="Como a IPRS Soluções em TI coleta, utiliza e protege seus dados pessoais, em conformidade com a Lei Geral de Proteção de Dados (LGPD)."
        path="/politica-de-privacidade"
      />

      <section className="relative pt-28 lg:pt-40 pb-12 overflow-hidden">
        <div className="absolute inset-0 grid-lines" aria-hidden="true" />
        <div className="container-x relative">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-techblue">Transparência</p>
          </Reveal>
          <Reveal delay={0.08}>
            <h1 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-graphite leading-[1.15]">
              Política de Privacidade
            </h1>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-6 text-base text-steel leading-relaxed max-w-2xl">
              A proteção dos seus dados é um compromisso da IPRS Soluções em TI. Esta política
              descreve como tratamos as informações coletadas neste site, em conformidade com a
              Lei Geral de Proteção de Dados Pessoais (LGPD).
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-20 sm:pb-24">
        <div className="container-x max-w-4xl">
          <div className="space-y-4">
            {SECTIONS.map((s, i) => (
              <Reveal key={s.title} delay={i * 0.04}>
                <article data-testid={`privacy-section-${i + 1}`} className="bg-white border border-line rounded-xl p-7 sm:p-8">
                  <h2 className="text-lg font-semibold text-graphite">{s.title}</h2>
                  <p className="mt-3 text-sm text-steel leading-relaxed">{s.body}</p>
                </article>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.1}>
            <p className="mt-8 text-xs text-steel/70 leading-relaxed">
              Última atualização: {new Date().toLocaleDateString("pt-BR", { year: "numeric", month: "long" })}.
              Esta política pode ser atualizada para refletir mudanças nos nossos processos ou na legislação aplicável.
            </p>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
